<template>
    <router-link to="/ticket-listing">Ticket Listing</router-link>
    <br>
    <router-link to="/admin/dashboard">Admin</router-link>
</template>
<script>
    export default {
        name: 'MainPage',
    }
</script>